import { type FC, type ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { buttonClasses, type ButtonSize, type ButtonVariant } from './Button';

export interface ButtonLinkProps extends Omit<LinkProps, 'className'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
  fullWidth?: boolean;
  children: ReactNode;
}

/**
 * ButtonLink - navigation that looks like a button. One focusable element, no nested <button>.
 */
export const ButtonLink: FC<ButtonLinkProps> = ({ variant = 'secondary', size = 'md', className, fullWidth = false, children, ...rest }) => (
  <Link className={buttonClasses({ variant, size, className: fullWidth ? `w-full ${className ?? ''}`.trim() : className })} {...rest}>
    {children}
  </Link>
);
